import { Helmet } from "react-helmet";

const defaultProfileImage ="https://imagedelivery.net/hAeIC__6Aj746x0RFU1joA/b640dc78-9146-4a0e-5d34-1d25ced2ce00/personalEmailSignature";

const MetaDescriptionUsers = ({ fetchData }) => {

  const helmetConfig = {
    gallery: {
      getTitle: (name) => `${name} | Suarte`,
      getDescription: (name) => `Buy and showcase unique paintings and original artworks from ${name} on Suarte. Discover its artists and start or add to your collection today.`,
      getSchema: (data) => ({
        "@type": "ProfilePage",
        "name": data.user_name || "Unnamed Gallery",
        "alternateName": data.user_username,
        "description": helmetConfig.gallery.getDescription(data.user_name),
        "image": data.user_image?.image_url ? `${data.user_image.image_url}w=1200` : defaultProfileImage,
        "url": `https://suarte.art/user/${data.user_username}`,
        "mainEntity": {
          "@type": "Organization",
          "name": data.user_name || "Unnamed Gallery",
          "logo": data.user_image?.image_url ? `${data.user_image.image_url}w=1200` : defaultProfileImage,
        },
        "interactionStatistic": [
          {
            "@type": "InteractionCounter",
            "interactionType": "http://schema.org/FollowAction",
            "userInteractionCount": data.user_profile_info?.user_inspiring || 0
          },
          {
            "@type": "InteractionCounter",
            "interactionType": "http://schema.org/LikeAction",
            "userInteractionCount": data.user_profile_info?.user_likes || 0
          },
          {
            "@type": "InteractionCounter",
            "interactionType": "http://schema.org/WriteAction",
            "userInteractionCount": data.user_profile_info?.user_artworks || 0
          },
        ]
      })
    },
    artist: {
      getTitle: (name) => `${name} | Suarte`,
      getDescription: (name) => `Discover ${name}'s art journey and their unique artworks on Suarte.`,
      getSchema: (data) => ({
        "@type": "Person",
        "name": data.user_name || "Anonymous Artist",
        "alternateName": data.gallery_artist?.artist_name || "Unknown Artist",
        "description": helmetConfig.artist.getDescription(data.user_name),
        "url": `https://suarte.art/user/${data.user_username}`,
        "image": data.user_image?.image_url ? `${data.user_image.image_url}w=400` : defaultProfileImage,
        "mainEntity": {
          "@type": "Person",
          "name": data.user_name || "Unnamed Artist",
          "logo": data.user_image?.image_url ? `${data.user_image.image_url}w=1200` : defaultProfileImage,
        },
        "interactionStatistic": [
          {
            "@type": "InteractionCounter",
            "interactionType": "http://schema.org/FollowAction",
            "userInteractionCount": data.user_profile_info?.user_inspiring || 0
          },
          {
            "@type": "InteractionCounter",
            "interactionType": "http://schema.org/LikeAction",
            "userInteractionCount": data.user_profile_info?.user_likes || 0
          },
          {
            "@type": "InteractionCounter",
            "interactionType": "http://schema.org/WriteAction",
            "userInteractionCount": data.user_profile_info?.user_artworks || 0
          },
        ],
      })
    },
    collector: {
      getTitle: (name) => `${name} | Suarte`,
      getDescription: (name) => `Explore the unique art collection curated by ${name} on Suarte.`,
      getSchema: (data) => ({
        "@type": "Person",
        "name": data.user_username || "Anonymous Collector",
        "alternateName": data.user_username,
        "url": `https://suarte.art/user/${data.user_username}`,
        "description": helmetConfig.collector.getDescription(data.user_username),
        "image": data.user_image?.image_url ? `${data.user_image.image_url}w=400` : defaultProfileImage,
        "mainEntity": {
          "@type": "Person",
          "name": data.user_username || "Unnamed Collector",
          "logo": data.user_image?.image_url ? `${data.user_image.image_url}w=1200` : defaultProfileImage,
        },
        "interactionStatistic": [
          {
            "@type": "InteractionCounter",
            "interactionType": "http://schema.org/FollowAction",
            "userInteractionCount": data.user_profile_info?.user_inspiring || 0
          },
          {
            "@type": "InteractionCounter",
            "interactionType": "http://schema.org/LikeAction",
            "userInteractionCount": data.user_profile_info?.user_likes || 0
          },
          {
            "@type": "InteractionCounter",
            "interactionType": "http://schema.org/WriteAction",
            "userInteractionCount": data.user_profile_info?.user_artworks || 0
          },
        ]
      })

    }
  };
  const userType = fetchData.user_type;
  const currentConfig = helmetConfig[userType];
  const title = currentConfig.getTitle(fetchData.user_name || fetchData.user_username);
  const description = currentConfig.getDescription(fetchData.user_name || fetchData.user_username);
  const schema = currentConfig.getSchema(fetchData);

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={schema.url} />
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      </Helmet>
    </>
  );
};

export default MetaDescriptionUsers;
